/* eslint-disable */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import styles from './GenericItemList.module.scss';
import { classes } from '../../../../Helpers';

function map(input, in_min, in_max, out_min, out_max) {
	return (
		((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
	);
}
function BuildItem({ data, scale }) {
	const [errorMsg, setErrorMsg] = useState('');

	return (
		<div
			className={classes(styles?.item)}
			style={{
				transform: `scale(${scale})`,
			}}
		>
			<div className={styles.img}>
				<span className={styles.completedText}>
					{`${data?.weight ?? ''} ${(data?.unit === 'gram' ? 'g' : data?.unit) ?? ''
						} `}
				</span>
				{data?.image && !errorMsg ? (
					<img
						style={{
							width: '100%',
							height: 'auto',
						}}
						src={data?.image}
						alt='prblm showing'
						onError={async () => {
							try {
								const res = await fetch(data.image, { method: 'HEAD' });
								if (!res.ok) {
									setErrorMsg(`Error ${res.status}`);
								} else {
									setErrorMsg('Corrupted');
								}
							} catch (e) {
								setErrorMsg('Blocked/CORS');
							}
						}}
					/>
				) : (
					<div
						style={{
							width: '100%',
							height: '50px', // Matches .img height constraint usually
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: '#f5f5f5',
							borderRadius: '4px',
							border: '1px dashed #ccc',
							padding: '4px'
						}}
					>
						<InfoOutlinedIcon style={{ fontSize: 18, color: '#999', marginBottom: '2px' }} />
						<Typography
							variant='caption'
							style={{
								fontSize: '8px',
								color: '#888',
								lineHeight: '1.1',
								textAlign: 'center'
							}}
						>
							{!data?.image ? 'No Source' : errorMsg}
						</Typography>
					</div>
				)}
			</div>
			<div className={styles.name}>
				<span>
					{data?.name?.length > 15
						? `${data?.name?.substring(0, 15)}..`
						: data?.name}
				</span>
			</div>
		</div>
	);
}

const minScale = 0.9;
const maxScale = 1.1;

function GenericItemList({ idKeyValueData, productsList }) {
	let minWeight = 0;
	let maxWeight = 0;
	const arraysData = Object.entries(idKeyValueData).map(([key, value]) => {
		return {
			...value,
			id: Number(key),
		};
	});
	arraysData?.forEach((ele) => {
		const thisWeight = Number(ele?.weight);
		if (minWeight > thisWeight) {
			minWeight = thisWeight;
		}
		if (maxWeight < thisWeight) {
			maxWeight = thisWeight;
		}
	});

	return (
		<>
			<div className={styles.root}>
				<div className={styles.list}>
					{arraysData?.map((data) => {
						const scale = map(
							data?.weight,
							minWeight,
							maxWeight,
							minScale,
							maxScale
						);
						const product = productsList?.find((prod) => {
							// eslint-disable-next-line eqeqeq
							return prod?.id == data?.id;
						});
						return (
							<BuildItem
								key={data?.id}
								data={{
									...data,
									image: product?.productImageUrl,
									name: product?.productName,
								}}
								scale={scale}
							/>
						);
					})}
				</div>
			</div>
			<div className={styles.arrow}>
				<ExpandMoreIcon
					sx={{
						fontSize: 20,
					}}
					color='white'
				/>
			</div>
		</>
	);
}

export default React.memo(GenericItemList);
